import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Portal } from 'react-portal';
import PropTypes from 'prop-types';
import { DragLayer } from 'react-dnd';
/* eslint-disable new-cap */

var layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0
};
var dragPreviewRef = null;

var onOffsetChange = function onOffsetChange(monitor) {
  if (!dragPreviewRef) {
    return;
  }

  var offset = monitor.getSourceClientOffset() || monitor.getInitialClientOffset();

  if (!offset) {
    return;
  }

  var transform = "translate(".concat(offset.x, "px, ").concat(offset.y, "px)");
  dragPreviewRef.style.transform = transform;
  dragPreviewRef.style['-webkit-transform'] = transform;
};

var CustomDragLayer = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomDragLayer, _React$Component);

  var _super = _createSuper(CustomDragLayer);

  function CustomDragLayer() {
    var _this;

    _classCallCheck(this, CustomDragLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "shouldRenderLayer", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
      var id = props.id,
          item = props.item,
          itemType = props.itemType,
          draggedType = props.draggedType,
          isDragging = props.isDragging;
      return isDragging && id === item.id && itemType === draggedType;
    });

    _defineProperty(_assertThisInitialized(_this), "renderPreview", function () {
      var offsetOfHandle = _this.props.offsetOfHandle;
      var styles = Object.assign({}, layerStyles, {
        left: -offsetOfHandle.x,
        top: -offsetOfHandle.y
      });
      return /*#__PURE__*/React.createElement("div", {
        style: styles,
        ref: function ref(node) {
          return dragPreviewRef = node;
        }
      }, _this.props.renderPreview({}));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPreviewInPortal", function () {
      return /*#__PURE__*/React.createElement(Portal, null, _this.renderPreview());
    });

    return _this;
  }

  _createClass(CustomDragLayer, [{
    key: "render",
    value: function render() {
      if (!this.shouldRenderLayer()) {
        return null;
      }

      return this.props.usePortal ? this.renderPreviewInPortal() : this.renderPreview();
    }
  }]);

  return CustomDragLayer;
}(React.Component);

CustomDragLayer.propTypes = {
  offsetOfHandle: PropTypes.object,
  item: PropTypes.object,
  itemType: PropTypes.string,
  draggedType: PropTypes.string,
  isDragging: PropTypes.bool,
  renderPreview: PropTypes.func,
  usePortal: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default DragLayer(function (monitor, props) {
  onOffsetChange(monitor);
  return {
    offsetOfHandle: props.offsetOfHandle,
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging()
  };
})(CustomDragLayer);